import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  IAccessControlSettings,
  getAllDefaultAccessSettings,
  fetchWorkspaceAccessSettings,
  saveAccessControlSettings,
} from 'wisestep-api';
import { WsButton } from 'wisestep-base';

import { SettingsHeader } from '../../components/SettingsHeader';
import { WsBreadCrumbs } from '../../components/WsBreadCrumbs/WsBreadCrumbs';
import { usePermissionContext } from '../../context';
import { warning, success } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';

import AddRoleAccessControl from './AddRoleAccessControl';
import { AccessContolBreadCrumbListAndTitle } from './helper';
import PermissionGrid from './PermissionGrid';

const LeadAccessControl = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [permissionData, setPermisionData] = useState<IAccessControlSettings[]>([]);

  const permissionContext = usePermissionContext();

  const module = 'LEAD';
  const url = 'invoicingservice';

  const expansionConfig = {
    VIEW: true,
    ADD: false,
    EDIT: false,
    DELETE: false,
  };

  useEffect(() => {
    permissionContext[module] && setPermisionData(permissionContext[module].permissions);
  }, [permissionContext]);

  const loadDefaultData = async () => {
    if (permissionContext.isAuthorized) {
      const response = await getAllDefaultAccessSettings(url, module);
      setPermisionData(response.data);
    }
  };

  const saveData = async () => {
    try {
      const response = await saveAccessControlSettings(url, module, permissionData);
      if (response.status === 200) {
        setNotification(success('Permissions saved Successfully'));
        if (permissionContext.setAccessControlSettingsContext) {
          permissionContext.setAccessControlSettingsContext({
            [module]: { permissions: permissionData },
          });
        }
      }
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };

  const cancelData = async () => {
    try {
      const workspaceAccessSettings = await fetchWorkspaceAccessSettings(url, module);
      if (workspaceAccessSettings.status === 200) {
        setPermisionData(workspaceAccessSettings.data);
        setNotification(success('Permissions are loaded Successfully'));
      } else {
        const response = await getAllDefaultAccessSettings(url, module);
        response.data ? setPermisionData(response.data) : setPermisionData([]);
      }
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };

  const handleLatestData = (data: IAccessControlSettings[]) => setPermisionData(data);

  return (
    <Box borderRadius={1.5}>
      <WsBreadCrumbs
        breadCrumbsList={AccessContolBreadCrumbListAndTitle['LEAD_ACCESS'].BreadcrumbsList}
      />
      <SettingsHeader backUrl="/access-control" title="Lead Access Control" />
      <Grid container borderRadius={1.5}>
        <Grid container item xs={12} my={3} justifyContent="space-between">
          <Grid item>
            <AddRoleAccessControl />
          </Grid>
          <Grid item display="flex" gap={1}>
            <WsButton variant="outlined" size="large" onClick={loadDefaultData}>
              Reset
            </WsButton>
            <WsButton variant="contained" size="large" type="submit" onClick={cancelData}>
              Cancel
            </WsButton>
            <WsButton variant="contained" size="large" type="submit" onClick={saveData}>
              Save
            </WsButton>
          </Grid>
        </Grid>
        <Grid item xs={12} mt={2} ml={2}>
          {permissionData.length > 0 && (
            <PermissionGrid
              accountPermissions={permissionData}
              handleChange={handleLatestData}
              expansionConfig={expansionConfig}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default LeadAccessControl;
